import React from 'react';
import './Content.css';
import Helpers from './Helpers';
// import Button from './Button';

class Content extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fontSize: 15,
			menu_status: "closed",
			mode: 0,
			modes: ["Quick-Modus","Quick-Modus ✓"],
			update: "",
			datetime: "",
			core_data: {},
			active_season: "2021",
			seasons: {},
			pilots: {},
			races: {},
			positions: {},
			bonuses: {},
			status: {},
			position_values: {},
			races_types: {
				normal: "Rennen",
				sprint: "Sprint"
			},
			positions_available: {
				normal : [1,2,3,4,5,6,7,8,9,10],
				sprint : [1,2,3]
			},
			fastest_lap_bonus: 1,
			ready: false,
			error: false,
			reset_state: {}
		}
		// this.toggle = this.toggle.bind(this)
	}

	componentDidMount() {
		this.fetchData();
	}

	openUrl(url) {
		window.open(url)
	}

	toggle_menu() {
		let status_local = this.state.menu_status;
		if(status_local==="closed") {
			status_local="open"
		}
		else {
			status_local="closed"
		}
		this.setState({
			menu_status: status_local
		})
	}


	toggle_mode() {
		let mode_local = this.state.mode;
		if(mode_local===0) {
			mode_local = 1
		}
		else {
			mode_local = 0
		}
		this.setState({
			mode: mode_local
		})
		this.toggle_menu();
	}
	
	urlVars() {
		let active_season = Helpers.getUrlVar("season");
				
		if(active_season && active_season.length>0) {
			this.setState({
				"active_season": active_season,
			})
		}
	}

	preProcess(data) {
		let last_pretipped_race = false;
		let first_untipped_race = false;

		// SEASONS
		data.seasons = Helpers.sorting(data.seasons,"year",-1);
		let seasons_local = {};
		let active_season_local = "2021";
		data.seasons.map((season,k) => {
			seasons_local[season['year']] = season;
			if(season['active']*1===1) {
				active_season_local = season['year']
			}
			return false
		})
		this.urlVars();

		// RACES
		data.races = Helpers.sorting(data.races,"date",1);
		let races_local = {};
		data.races.map((race,k) => {
			if(race['season']===active_season_local) {
				race.ux_status = "";
				race.pilots = {
					dict: {},
					arr: []
				}
				race.positions_available = JSON.parse(JSON.stringify(this.state.positions_available[race.type]));
				race.positions_all = JSON.parse(JSON.stringify(this.state.positions_available[race.type]));
				races_local[race['id']] = race
			}
			return false
		})

		// STATUS
		let status_local = {};
		data.status.map((status,k) => {
			status_local[status['id']] = status
			return false
		})

		// POSITION_VALUES
		let position_values_local = {};
		data.position_values.map((position_value,k) => {
			if(position_value['season']===active_season_local) {
				position_values_local[position_value['position']] = position_value
			}
			return false
		})

		this.setState({
			position_values : position_values_local,
			status : status_local
		})

		// PILOTS
		data.pilots = Helpers.sorting(data.pilots,"id",1);
		let pilots_local = {};
		data.pilots.map((pilot,k) => {
			if(pilot['season']===active_season_local) {
				pilot.points_total = 0;
				pilot.bonuses_total = 0;
				pilot.standing = 999;
				pilot.race_count = 0;
				pilot.win_count = 0;
				pilots_local[pilot['id']] = pilot
			}
			return false
		})

		// POSITIONS
		data.positions.map((positions,k) => {
			if(positions['season']===active_season_local) {
				let pilot_id_local = positions['pilot'];
				Helpers.o2a(races_local).items.map((race,l) => {
					let race_position_per_pilot_local = positions[race.id]*1
					if (race_position_per_pilot_local>10) {
						race_position_per_pilot_local = 999;
					}
					let pilot_local = {
						id: pilot_id_local,
						name: pilots_local[pilot_id_local].name,
						position: race_position_per_pilot_local,
						fastest_lap: false,
						points: 0,
						tipped: ""
					}
					let pos_index = races_local[race['id']].positions_available.indexOf(race_position_per_pilot_local)
					if(pos_index>-1) {
						races_local[race['id']].positions_available.splice(pos_index,1);
						pilot_local.tipped = "pilot_tipped";
					}
					races_local[race['id']].pilots.dict[pilot_id_local] = pilot_local;
					return false
				})	

			}
			return false
		})

		// BONUSES
		data.bonuses.map((bonuses,k) => {
			if(bonuses['season']===active_season_local) {
				let pilot_id_local = bonuses['pilot'];
				Helpers.o2a(races_local).items.map((race,l) => {
					if(parseInt(bonuses[race.id])>=1) {
						races_local[race['id']].pilots.dict[pilot_id_local].fastest_lap = true
					}
					return false
				})	
			}
			return false
		})

		Helpers.o2a(races_local).items.map((race,l) => {
			if(race.positions_available.length<=0) {
				race.ux_status = "race_pretipped"
				last_pretipped_race = race.id;
			}
			else {
				if(last_pretipped_race!==false && first_untipped_race===false) {
					first_untipped_race = race.id
				}				
			}
			return false
		})

		races_local = this.calc_points_per_all_races(races_local)
		let pilots_local_dict = this.calc_points_per_pilot(pilots_local,races_local)
		
		this.setState({
			seasons: seasons_local,
			pilots: pilots_local_dict,
			races: races_local,
			active_season: active_season_local,
			ready: true,
		})

		setTimeout(function(){
			this.jump_to(first_untipped_race)
		}.bind(this),500)

		// this.setState({
		// 	reset_state:this.state
		// })

	}

	fetchData() {
		let d = new Date();
		let cacheBuster = (d.getMonth()+1)+"-"+d.getDate()+"-"+d.getHours()+"-"+d.getMinutes();

		let url="./data/bulk.json?"+cacheBuster;

		fetch(url)
		.then(response => response.json())
		.then(
			(response) => {
				this.setState({
					update :  response.meta.update,
					}
				)
				this.preProcess(response.data)

				//
			},
			// Note: it's important to handle errors here
			// instead of a catch() block so that we don't swallow
			// exceptions from actual bugs in components.
			(error) => {
				console.log("error")
				this.setState({
					error: true,
					ready: false
				});
			}
		)

	}

	write_pos(position) {
		let pos_string = position;
		if(position*1>10) {
			pos_string = "";
		}
		else {
			pos_string = position+".";
		}
		return pos_string
	}

	calc_pseudo(rank) {
		let padding = this.state.fontSize*0.2;
		let height = this.state.fontSize+(3*padding)
		let top = (rank-1)*(height)
		let tbodyHeight = (this.state.pilots.arr.length)*(height)+this.state.pilots.arr.length/2;
		let answer = {
			top: top,
			padding: padding,
			height: height,
			tbodyHeight: tbodyHeight
		}
		return answer
	}

	reset() {
		window.location.reload();
		return false
	}

	tipp(race_id,pilot_id,position) {
		let races_local = JSON.parse(JSON.stringify(this.state.races));
		let old_position = races_local[race_id].pilots.dict[pilot_id].position;

		races_local[race_id].pilots.dict[pilot_id].position = position
		races_local[race_id].pilots.dict[pilot_id].tipped = "pilot_tipped"

		if(old_position>0 && parseInt(old_position)<999) {
			races_local[race_id].positions_available.push(old_position)
			races_local[race_id].positions_available.sort(function(a, b){return a-b});
		}

		let pos_index = races_local[race_id].positions_available.indexOf(position)
		if(pos_index>-1) {
			races_local[race_id].positions_available.splice(pos_index,1);
		}
		// LOGIC 1 ------------------------------------------
		races_local[race_id] = this.calc_points_per_race(races_local[race_id])
		// LOGIC 1 ------------------------------------------

		let pilots_local = this.calc_points_per_pilot(this.state.pilots.dict,races_local)

		// races_local = this.check_race_status(races_local);

		this.setState({
			races:races_local,
			pilots: pilots_local
		})

		this.blink_pilot(pilot_id,race_id)

		if(this.state.mode===1) {
			if(races_local[race_id].positions_available.length<=races_local[race_id].positions_all.length-3 && races_local[race_id].positions_available.length>0) {
				this.auto_tipp(races_local[race_id])
			}
		}
	}

	auto_tipp(race_local) {
		// let races_local = JSON.parse(JSON.stringify(this.state.races));
		// let race_local = races_local[race_id];
		let run = true;
		race_local.pilots.arr.sort(() => Math.random() - 0.5);
		Helpers.o2a(race_local.pilots.arr).items.map((pilot,k) => {
			if(run===true) {
				if(pilot.position===999) {
					let ran_pos = race_local.positions_available[Math.floor(Math.random()*race_local.positions_available.length)];
					run = false;
					setTimeout(
						function() {
							this.tipp(race_local.id,pilot.id,ran_pos)
						}.bind(this),1
					)
					//console.log(pilot)
				}
			}

			return false;
		})


	}

	calc_points_per_all_races(races_local) {
		// LOGIC 1 ------------------------------------------
		Helpers.o2a(races_local).items.map((race,l) => {
			if(race.ux_status!=="race_pretipped") {
				if(race.positions_available.length<=0) {
					race.ux_status = "race_tipped"
				}
				else {
					race.ux_status = ""
				}
			}
			
			race.pilots.arr = [];
			Helpers.o2a(race.pilots.dict).items.map((pilot,l) => {
				pilot.points = this.calc_points_per_race_per_pilot(pilot.position,race.type,race.status,pilot.fastest_lap)
				race.pilots.arr.push(pilot);
				return false
			})
			// race.pilots.arr = Helpers.sorting(race.pilots.arr,"id",1)
			race.pilots.arr = Helpers.sorting(race.pilots.arr,"points",-1)
			race.pilots.arr = Helpers.sorting(race.pilots.arr,"position",1)
			return false
		})
		return races_local
		// LOGIC 1 ------------------------------------------
	}

	calc_points_per_race(race) {
		// LOGIC 1 ------------------------------------------
		
		race.pilots.arr = [];
		Helpers.o2a(race.pilots.dict).items.map((pilot,l) => {
			pilot.points = this.calc_points_per_race_per_pilot(pilot.position,race.type,race.status,pilot.fastest_lap)
			race.pilots.arr.push(pilot);
			return false
		})
		race.pilots.arr = Helpers.sorting(race.pilots.arr,"points",-1)
		race.pilots.arr = Helpers.sorting(race.pilots.arr,"position",1)
		
		if(race.positions_available.length<=0 && race.ux_status!=="race_pretipped") {
			race.ux_status = "race_tipped"
		}
		else {
			race.ux_status = ""
		}

		return race
		// LOGIC 1 ------------------------------------------
	}

	reset_pilot(race_id,pilot_id) {
		let races_local = JSON.parse(JSON.stringify(this.state.races));
		let old_position = races_local[race_id].pilots.dict[pilot_id].position;

		races_local[race_id].pilots.dict[pilot_id].position = 999
		races_local[race_id].pilots.dict[pilot_id].tipped = ""
		races_local[race_id].positions_available.push(old_position);

		// LOGIC 1 ------------------------------------------
		races_local[race_id] = this.calc_points_per_race(races_local[race_id])

		// LOGIC 1 ------------------------------------------

		races_local[race_id].positions_available.sort(function(a, b){return a-b});
		let pilots_local = this.calc_points_per_pilot(this.state.pilots.dict,races_local)


		this.setState({
			races:races_local,
			pilots: pilots_local
		})

		this.blink_pilot(pilot_id,race_id)


	}

	toggle_fastest_lap(race_id,pilot_id) {
		let races_local = JSON.parse(JSON.stringify(this.state.races));
		if(races_local[race_id].ux_status !== "race_pretipped") {
			Helpers.o2a(races_local[race_id].pilots.dict).items.map((pilot,l) => {
				if(pilot.id===pilot_id) {
					if(pilot.fastest_lap===true) {
						pilot.fastest_lap = false;
					}
					else {
						pilot.fastest_lap = true;
					}
				}
				else {
					pilot.fastest_lap = false;
				}
				return false;
			})

			// LOGIC 1 ------------------------------------------
			// races_local = this.calc_points_per_race(races_local)
			races_local[race_id] = this.calc_points_per_race(races_local[race_id])
			// LOGIC 1 ------------------------------------------

			let pilots_local = this.calc_points_per_pilot(this.state.pilots.dict,races_local)

			this.setState({
				races:races_local,
				pilots: pilots_local
			})
		}
		this.blink_pilot(pilot_id,race_id)
	}

	
	calc_points_per_race_per_pilot(position,race_type,race_status,fastest_lap) {
		let points_local = 0;
		let weight = 1;
		if(this.state.status.hasOwnProperty(race_status)) {
			weight = this.state.status[race_status].weight;
		}

		if(this.state.position_values.hasOwnProperty(position) && this.state.position_values[position].hasOwnProperty(race_type)) {
			points_local = parseInt(this.state.position_values[position][race_type]);
		}

		points_local = points_local * weight;

		if(fastest_lap) {
			points_local+=this.state.fastest_lap_bonus;
		}
		return points_local
	}

	calc_points_per_pilot(pilots_dict,races) {
		let pilots_arr = [];
		Helpers.o2a(pilots_dict).items.map((pilot,k) => {
			pilot.points_total = 0;
			pilot.bonuses_total = 0;
			pilot.standing = 999;
			pilot.race_count = 0;
			pilot.win_count = 0;
			return false;
		})
		Helpers.o2a(races).items.map((race,k) => {
			Helpers.o2a(race.pilots.dict).items.map((pil,l) => {
				pilots_dict[pil.id].points_total += pil.points

				if(race.ux_status==='race_tipped' || race.ux_status==='race_pretipped' || parseInt(pil.position)<999) {
					pilots_dict[pil.id].race_count += 1
				}

				if(pil.fastest_lap) {
					pilots_dict[pil.id].bonuses_total += this.state.fastest_lap_bonus;
				}

				if(race.type==="normal") {
					if(race.ux_status==='race_tipped' || race.ux_status==='race_pretipped' || parseInt(pil.position)<999) {
						if(pil.position===1) {
							pilots_dict[pil.id].win_count += 1;
						}
					}
				}
				

				return false
			})

			// console.log(race);
			return false
		})

		Helpers.o2a(pilots_dict).items.map((pilot,k) => {
			pilots_arr.push(pilot);
			return false;
		})


		pilots_arr = Helpers.sorting(pilots_arr,"win_count",-1)
		pilots_arr = Helpers.sorting(pilots_arr,"points_total",-1)

		let standing_iterator = 1;
		pilots_arr.map((pilot,k) => {
			pilot.standing = standing_iterator;
			standing_iterator += 1;
			pilots_dict[pilot.id] = pilot;
			return false;
		})

		let pilots = {
			dict: pilots_dict,
			arr: pilots_arr
		}

		return pilots
	}

	jump_to(race_id) {
		// let element = document.getElementById(race_id);
		// let target = document.getElementById('races-wrapper');
		// target.scrollTop = element.offsetTop;
		this.mark_active_race(race_id)
	}

	mark_active_race(race_id) {
		// Helpers.o2a(this.state.races).items.map((race,k) => {
		// 	let element = document.getElementById(race.id);
		// 	let target = document.getElementById('races-wrapper');
		// 	document.getElementsByClassName('race-button-'+race.id)[0].classList.remove("marked")
		// 	if(target.scrollTop>=element.offsetTop && target.scrollTop<element.offsetTop+element.offsetHeight*0.75) {
		// 		document.getElementsByClassName('race-button-'+race.id)[0].classList.add("marked")
		// 	}
		// 	return false
		// })

		Helpers.o2a(this.state.races).items.map((race,k) => {
			document.getElementsByClassName('race_'+race.id)[0].classList.add("race-hidden")
			document.getElementsByClassName('race_'+race.id)[0].classList.remove("race-visible")
			return false;
		})

		document.getElementsByClassName('race_'+race_id)[0].classList.remove("race-hidden")
		document.getElementsByClassName('race_'+race_id)[0].classList.add("race-visible")

	}

	blink_pilot(pilot_id,race_id) {
		this.highlight_pilot(pilot_id,race_id,1);
		setTimeout(function(){
			this.highlight_pilot(pilot_id,race_id,0)
		}.bind(this),500)
	}

	highlight_pilot(pilot_id,race_id,state) {
		let element = document.querySelector('.race_'+race_id+' .row-pilot_'+pilot_id);
		if(state===1) {
			if(element) {
				setTimeout(function(){
					element.classList.add("highlight")
				},10)			
			}		
			let element_2 = document.querySelector('.standings-wrapper .row-pilot_'+pilot_id);
			if(element_2) {
				setTimeout(function(){
					element_2.classList.add("highlight")
				},10)			
			}
		}

		if(state===0) {
			if(element) {
				setTimeout(function(){
					element.classList.remove("highlight")
				},10)			
			}		
			let element_2 = document.querySelector('.standings-wrapper .row-pilot_'+pilot_id);
			if(element_2) {
				setTimeout(function(){
					element_2.classList.remove("highlight")
				},10)			
			}
		}

		
	}

	pilots_switch(pilots,ux_status) {
		if(ux_status==="race_pretipped") {
			return(pilots.arr)
		}
		else {
			return(pilots.dict)

		}
	}


	render() {

		return(
			<div className="content"
			
			>
				<header className="header">
					<div className='header-container'>
						<h1 className='blick-header'>Formel 1 Punkte-Rechner</h1>
						<img 
							onClick = 	{() => {
								this.toggle_menu() 
								}
							}
						className="canihaz" alt="Filter" src="img/cheeseburger.png"></img>						
					</div>
					<nav className={'menu-wrapper menu-wrapper-'+this.state.menu_status}>
						<div className='menu'>
						{this.state.ready === true &&
							<div className='menu-item-wrapper'>
								{/* <h2>Rennen</h2> */}
								<nav className='races-nav-wrapper'>
									<ul className='races-nav'>
									{
										Helpers.o2a(this.state.races).items.map((race,k) => {
											return(
												<li className={'race-button race-button-'+race.id+' '+race.ux_status}
													key = {race.id}
													onClick = 	{() => {
														this.jump_to(race.id) 
														}
													}
												>{race.name}</li>
											)
										})
									}
									</ul>
								</nav>
							</div>						
						}		
						<div className='menu-item-wrapper'>
							<ul className='mode-nav'>
								{/* <li className={'mode-button mode-button-'+this.state.mode}
									onClick = 	{() => {
										this.toggle_mode() 
										}
									}
								>
									{this.state.modes[this.state.mode]}
								</li>   */}
								<li className={'reset-button'}
									onClick = 	{() => {
										this.reset() 
										}
									}
								>
									Neustart
								</li>  
							</ul>
						</div>


						</div>
					</nav>
					{/* <div className='lead'>
						Tippen Sie die verbleibenden Rennen der Saison, um den möglichen Weltmeister zu berechnen. Tippen Sie auf das Menu oben, um die Streckenauswahl anzuzeigen.
					</div> */}

				</header>
				{this.state.ready === false &&
					<div className='loading'>
						<div className='spinner-ring'><div></div><div></div><div></div><div></div></div>
					</div>
				}

				{this.state.ready === true &&

				<div className="main">
					<section className='section section-races'>
						
						<div className='races-wrapper' id = 'races-wrapper'
							onScroll = 	{() => {
							//	this.mark_active_race()
								}
							}	
						>
							{
							Helpers.o2a(this.state.races).items.map((race,k) => {
								return(
									<div className={'race-wrapper '+race.ux_status + ' race_'+race.id + ' race-type_' + race.type + ' race-status_' + race.status + ' mode_' + this.state.mode} key = {race.id} id={race.id}>
										<div className='race-info'>
											<h3 className='column race-name'>
												{race.name}
												
											</h3>
											<div className='race-info-item race-info-item-race'>
												{race.race}
											</div>
											<div className='race-info-item race-info-item-date'>
												{/* {race.date} */}
												{Helpers.write_date(race.date,"D. Month")}
											</div>
											{/* <div className='race-info-item race-info-item-type'>
												{this.state.races_types[""+race.type]}
											</div>										 */}
											<div className='race-info-item race-info-item-status'>
												{this.state.status[race.status].name}
											</div>
											<div className='tick'>✓</div>									
										</div>
										<div className='pilots-wrapper'>
											{
												<table>
													<thead>
														<tr>
															<th className='column column-position'>
																#
															</th>
															<th className='column column-name column-pilot-name'>
																Fahrer
															</th>
															<th className='column column-position_buttons'>
																Plätze 
															</th>
															<th className='column column-fastest_lap'>
																<span className='lv'>Bonus</span>
																<span className='sv'>Bon.</span>
															</th>
															<th className='column column-points'>
																<span className='lv'>Punkte</span>
																<span className='sv'>Pkt.</span>
															</th>
														</tr>
													</thead>
													<tbody>
														{
															// race.pilots.arr.map((pilot,i) => {
															//Helpers.o2a(race.pilots.arr).items.map((pilot,i) => {
															//Helpers.o2a(race.pilots.dict).items.map((pilot,i) => {
															Helpers.o2a(this.pilots_switch(race.pilots,race.ux_status)).items.map((pilot,i) => {
																return(
																	<tr key = {pilot.id} className={'row-pilot row-pilot_'+pilot.id+' row-'+pilot.tipped + ' row-position_'+pilot.position}>
																		<td className='column column-position'><div className='position-wrapper'>{this.write_pos(pilot.position)}</div></td>
																		<td className='column column-name column-pilot_name'>{pilot.name}</td>
																		<td className='column column-position_buttons'>
																			<div className='position-buttons-wrapper'>
																			{
																				race.positions_all.map((pos,m) => {
																					let cls = " "
																					if(pos===pilot.position){
																						cls = "self-taken"
																					}
																					else if(race.positions_available.indexOf(pos)<=-1) {
																						cls = "taken"
																					}
																					return(
																						<div key={pos} className={'position-button position-button-'+pos+" "+cls}
																							onClick = 	{() => {
																								if(cls!=='taken') {
																									this.tipp(race.id,pilot.id,pos) 
																								}
																								if(cls==='self-taken') {
																									this.reset_pilot(race.id,pilot.id) 

																								}
																							}
																							}
																						>
																							{pos}
																						</div>

																					)
																				})
																			}
																			<div className='reset-button reset-pilot-button'
																				onClick = 	{() => {
																					this.reset_pilot(race.id,pilot.id) 
																					}
																				}
																			>
																				Reset
																			</div>
																			</div>
																		</td>
																		<td className={'column column-fastest_lap column-fastest_lap_'+pilot.fastest_lap}>
																			
																			<div className='fastest-lap-button'
																					onClick = 	{() => {
																						this.toggle_fastest_lap(race.id,pilot.id) 
																						}
																					}																			
																			>

																			</div>
																		</td>																		
																		<td className='column column-points'>
																			{pilot.points}
																		</td>

																	</tr>
																)
															})
														}
												
													</tbody>
												</table>
											}

										</div>
									</div>
										
								)
							})

							}
						</div>
					</section>



					
					<section className='section section-standings'>
						<h2>Rangliste</h2>
						<div className='standings-wrapper'>

							<div className='pseudo-table'
								style = {{
									fontSize:this.state.fontSize,
									height:this.calc_pseudo(0)['tableHeight']
								}}
							>
								<div className='pseudo-thead'>
									<div className='pseudo-tr'>
										<div className='pseudo-th column-standing'>
											#
										</div>
										<div className='pseudo-th column-name'>
											Fahrer
										</div>
										<div className='pseudo-th column-race_count'>
											Rennen
										</div>
										<div className='pseudo-th column-win_count'>
											Siege
										</div>
										<div className='pseudo-th column-points'>
											Punkte 
										</div>		
									</div>
								</div>
								<ul className='pseudo-tbody'
									style = {{
										height:this.calc_pseudo(1)['tbodyHeight']
									}}
								>
									{
									Helpers.o2a(this.state.pilots.dict).items.map((pilot,k) => {
										return(
											<li key = {pilot.id} className={'pseudo-tr row-pilot_'+pilot.id + ' row-standing_'+pilot.standing}
												style = {{
													top:this.calc_pseudo(pilot.standing)['top'],
													padding:this.calc_pseudo(pilot.standing)['padding'],
													height:this.calc_pseudo(pilot.standing)['height']
												}}
											>
												<div className='pseudo-td column-standing'>
													{pilot.standing}.
												</div>
												<div className='pseudo-td column-name'>
													{pilot.full_name}
												</div>
												<div className='pseudo-td column-race_count'>
													{pilot.race_count}
												</div>	
												<div className='pseudo-td column-win_count'>
													{pilot.win_count}
												</div>
												<div className='pseudo-td column-points'>
													{pilot.points_total} 
												</div>
												
											</li>
										)
									})
									}
								</ul>
							
							</div>
						</div>
					</section>

					<section className='section section-help'>
						<ul className='help-items'>
							<li>
								Tippen Sie die verbleibenden Rennen der Saison, um den möglichen Weltmeister zu bestimmen.
							</li>
							<li>
								Mit der <b>Bonus</b>-Option kann ein zusätzlicher Punkt für die schnellste Runde des Rennens vergeben werden.
							</li>
							<li>
								Die <b>Streckenauswahl</b> wird mit dem Menu-Button oben rechts angezeigt. 
							</li>
							{/* <li>
								In diesem Menu kann auch der <b>Quick-Modus</b> aktiviert werden. Im Quick-Modus werden nur Plätze 1 bis 3 getippt und die restlichen Ränge zufällig vergeben.
							</li> */}
						</ul>
					</section>

			

				</div>

				}

				<footer className="blick-footer">
					© Blick Visuals 2021, rtp.
				</footer>
			</div>
		)
	}
}


export default Content;
